import React from 'react'
import { isEmpty } from 'lodash'
import { Container, Row, Button } from '@paypalcorp/pp-react'
import { useApplicationContext } from '../../../../../provider'
import data from '../../../../content/home/home.en-XC.yaml'

import './style.css'

const Banner = () => {
  const { user } = useApplicationContext()
  const userLoggedOut = !isEmpty(user) && !user.loggedIn

  return (
    <section
      className={
        !userLoggedOut
          ? 'homePage-banner homePage-banner_loggedIn'
          : 'homePage-banner'
      }
    >
      <Container>
        <Row>
          <h2 className="bannerTitle">{data.content.carousel.title}</h2>
        </Row>
        <Row>
          <h1 className="bannerSubTitle">{data.content.carousel.headline}</h1>
        </Row>
        <Row>
          <p className="bannerBody">{data.content.carousel.description}</p>
        </Row>
        <Row>
          <div className="bannerButtonWrapper">
            <a
              href={`${data.content.carousel.url}`}
              className="getApiBtn"
              target="_blank"
              rel="noreferrer"
            >
              {data.content.carousel.buttonText}
            </a>
          </div>
        </Row>
      </Container>
    </section>
  )
}

export default Banner
